import { gql } from '@apollo/client';

// Progreso físico del cliente (3 fotos lateral/frente/espalda + parámetros). URLs presignadas
// (privadas; expiran). El cliente puede compartir su progreso con entrenadores específicos.

const FIELDS = `
  id before_image_url after_image_url
  lateral_image_url front_image_url back_image_url note
  weight body_fat waist hip chest arm leg taken_at created_at
`;

const TRAINER_FIELDS = 'id full_name photo';

export const MY_PHYSICAL_PROGRESS = gql`
  query MyPhysicalProgress { myPhysicalProgress { ${FIELDS} } }
`;

export const CLIENT_PHYSICAL_PROGRESS = gql`
  query ClientPhysicalProgress($clientId: ID!) {
    clientPhysicalProgress(client_id: $clientId) { ${FIELDS} }
  }
`;

export const SUBMIT_PHYSICAL_PROGRESS = gql`
  mutation SubmitPhysicalProgress($input: PhysicalProgressInput!) {
    submitPhysicalProgress(input: $input) { ${FIELDS} }
  }
`;

export const UPDATE_PHYSICAL_PROGRESS = gql`
  mutation UpdatePhysicalProgress($id: ID!, $input: PhysicalProgressInput!) {
    updatePhysicalProgress(id: $id, input: $input) { ${FIELDS} }
  }
`;

export const DELETE_PHYSICAL_PROGRESS = gql`
  mutation DeletePhysicalProgress($id: ID!) { deletePhysicalProgress(id: $id) }
`;

/* ----------------------------- Compartir progreso ----------------------------- */
export const MY_PROGRESS_SHARES = gql`
  query MyProgressShares { myProgressShares { id trainer { ${TRAINER_FIELDS} } } }
`;

export const SHAREABLE_TRAINERS = gql`
  query ShareableTrainers { shareableTrainers { ${TRAINER_FIELDS} } }
`;

export const SHARE_PHYSICAL_PROGRESS = gql`
  mutation SharePhysicalProgress($trainerIds: [ID!]!) {
    sharePhysicalProgress(trainer_ids: $trainerIds) { id trainer { ${TRAINER_FIELDS} } }
  }
`;

export const REVOKE_PHYSICAL_PROGRESS_SHARE = gql`
  mutation RevokePhysicalProgressShare($trainerId: ID!) {
    revokePhysicalProgressShare(trainer_id: $trainerId)
  }
`;

/* ------------------------------- Observaciones -------------------------------- */
export const CLIENT_PROGRESS_OBSERVATIONS = gql`
  query ClientProgressObservations($clientId: ID!) {
    clientProgressObservations(client_id: $clientId) {
      id body created_at trainer { ${TRAINER_FIELDS} }
    }
  }
`;

export const ADD_PROGRESS_OBSERVATION = gql`
  mutation AddProgressObservation($clientId: ID!, $body: String!) {
    addProgressObservation(client_id: $clientId, body: $body) {
      id body created_at trainer { ${TRAINER_FIELDS} }
    }
  }
`;

/* ------------------------------ Notificar mejora ------------------------------ */
export const NOTIFY_PROGRESS_IMPROVEMENT = gql`
  mutation NotifyProgressImprovement($fromId: ID!, $toId: ID!) {
    notifyProgressImprovement(from_id: $fromId, to_id: $toId)
  }
`;
